module.exports = __webpack_public_path__ + "img/features-actor-state-machine.bd7be79c.png";